// extracted by mini-css-extract-plugin
module.exports = {"background":"animated-background_background__2FhEP","fade":"animated-background_fade__5j78A","media":"animated-background_media__1qOmu"};